export default [
  {
    path: '/people',
    name: 'people',
    component: () => import(/* webpackChunkName: "people" */ './People.vue'),
    redirect: { name: 'people-people' },
    children: [
      {
        path: 'people',
        name: 'people-people',
        component: () => import(/* webpackChunkName: "people" */ './people/People.vue'),
      },
    ],
  },
];
